import { render } from "./TvmWebIframeRedirect.vue?vue&type=template&id=918bd2b0&scoped=true"
import script from "./TvmWebIframeRedirect.vue?vue&type=script&lang=js"
export * from "./TvmWebIframeRedirect.vue?vue&type=script&lang=js"

import "./TvmWebIframeRedirect.vue?vue&type=style&index=0&id=918bd2b0&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-918bd2b0"]])

export default __exports__